export default "__VITE_ASSET__7f23b7d2__"